module.exports = "<style>\n    div .google-visualization-tooltip>ul>li>span {\n        white-space: nowrap\n    }\n</style>\n<div flex layout=\"row\" layout-align=\"start center\" layout-wrap style=\"overflow-x:auto;\">\n    <div class=\"md-whiteframe-3dp\" flex id=\"singlechart\" flex style=\"margin:8px; height: 98%;\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/single_chart/views/single_chart.html
// module id = 1364
// module chunks = 438